const accesibility = document.querySelector(".accesibility");

if (accesibility) {
  const selectors = {
    handler: accesibility.querySelector(".accesibility__button--handler"),
    plusFont: accesibility.querySelector(".accesibility__elements--plus-fonts"),
    minusFont: accesibility.querySelector(
      ".accesibility__elements--minus-fonts"
    ),
    reset: accesibility.querySelector(".accesibility__button--reset"),
  };

  const fontSizes = {
    min: 40,
    default: 62.5,
    max: 70,
    step: 1,
  };

  let currentFontSize = fontSizes.default;

  selectors.handler.addEventListener("click", () => {
    accesibility.classList.toggle("isOpen");
  });

  selectors.plusFont.addEventListener("click", () => {
    if (currentFontSize < fontSizes.max) {
      currentFontSize = parseFloat(
        (currentFontSize + fontSizes.step).toFixed(1)
      );
      updateFontSize();
    }
  });

  selectors.minusFont.addEventListener("click", () => {
    if (currentFontSize > fontSizes.min) {
      currentFontSize = parseFloat(
        (currentFontSize - fontSizes.step).toFixed(1)
      );
      updateFontSize();
    }
  });

  if (selectors.reset) {
    selectors.reset.addEventListener("click", () => {
      resetAccessibility();
    });
  }

  function updateFontSize() {
    document.documentElement.style.fontSize = `${currentFontSize}%`;
    localStorage.setItem("accessibilityFontSize", currentFontSize);
  }

  function resetAccessibility() {
    currentFontSize = fontSizes.default;
    document.documentElement.style.fontSize = "";
    localStorage.removeItem("accessibilityFontSize");
  }

  function loadPreferences() {
    const savedFontSize = parseFloat(
      localStorage.getItem("accessibilityFontSize")
    );

    if (savedFontSize && !isNaN(savedFontSize)) {
      currentFontSize = Math.min(
        Math.max(savedFontSize, fontSizes.min),
        fontSizes.max
      );
      updateFontSize();
    }
  }

  loadPreferences();
}
